import { render, staticRenderFns } from "./SiteContractorNewForm.vue?vue&type=template&id=23b19675&"
import script from "./SiteContractorNewForm.vue?vue&type=script&lang=js&"
export * from "./SiteContractorNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports